var map = {
	"./logo-alphabet.svg": 572,
	"./logo-amazon-2.svg": 573,
	"./logo-amazon.svg": 636,
	"./logo-azercell.svg": 637,
	"./logo-bank-of-america.svg": 638,
	"./logo-barclays.svg": 639,
	"./logo-bbc.svg": 640,
	"./logo-bloomberg.svg": 574,
	"./logo-bnp-paribas.svg": 641,
	"./logo-booking.svg": 642,
	"./logo-citibank.svg": 643,
	"./logo-cnbc.svg": 575,
	"./logo-cnbc2.svg": 644,
	"./logo-coca-cola-auto.svg": 571,
	"./logo-coca-cola-white.svg": 1658,
	"./logo-coca-cola.svg": 645,
	"./logo-deloitte.svg": 646,
	"./logo-experian.svg": 647,
	"./logo-facebook.svg": 648,
	"./logo-forbes.svg": 576,
	"./logo-g.svg": 1659,
	"./logo-goldman-sachs-new.svg": 649,
	"./logo-goldman-sachs.svg": 1526,
	"./logo-google-new.svg": 650,
	"./logo-google.svg": 651,
	"./logo-h.svg": 652,
	"./logo-henkel.svg": 653,
	"./logo-hsbc-new.svg": 654,
	"./logo-hsbc.svg": 1524,
	"./logo-ikea-new.svg": 655,
	"./logo-ikea.svg": 1660,
	"./logo-infineon.svg": 656,
	"./logo-instagram-icon.svg": 569,
	"./logo-instagram.svg": 657,
	"./logo-jp-morgan.svg": 658,
	"./logo-jti.svg": 659,
	"./logo-linkedin.svg": 660,
	"./logo-meta-new.svg": 568,
	"./logo-meta.svg": 1527,
	"./logo-morgan-stanley-new.svg": 661,
	"./logo-morgan-stanley.svg": 1525,
	"./logo-netflix.svg": 1522,
	"./logo-oracle.svg": 577,
	"./logo-paypal.svg": 662,
	"./logo-pwc-new.svg": 570,
	"./logo-pwc.svg": 1661,
	"./logo-spotify.svg": 1523,
	"./logo-tesla.svg": 663,
	"./logo-usa-today.svg": 578,
	"./logo-visa.svg": 664,
	"./logo-walmart.svg": 579,
	"./logo-wsj.svg": 580,
	"./logo-youtube.svg": 665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1148;